import React, { useMemo } from "react";
import Dashboard from "components/dashboard";
import { PageSection, PageHeaderBar } from "components/page";
import { useQuery, QueryResponseHandler } from "components/graphql";
import { GraphicSetData, GraphicSetLayoutData, getGraphicSetQueryWithAssets, ActionButtons } from "./details-page";
import { deleteGraphicSetMutation } from "./table";

const orderLayouts = graphicSet => {
  if (graphicSet && graphicSet.layouts) {
    graphicSet.layouts.sort((a, b) => a.order - b.order);
  }
  return graphicSet;
};

const GraphicSetDetailsPage = ({
  match: {
    params: { id, customerId },
  },
  history,
}) => {
  const query = useMemo(() => getGraphicSetQueryWithAssets(id, customerId), [id, customerId]);
  const { data, loading, error } = useQuery(query);
  const graphicSet = orderLayouts(data.graphicset);

  const graphicSetName = graphicSet ? graphicSet.name : "";
  

  return (
    <Dashboard>
      <QueryResponseHandler error={error} loading={loading} elements={graphicSet}>
        <PageHeaderBar
          showBackButton
          title="app.page.graphicset.details.title"
          titleParams={{ graphicSetName: graphicSet ? graphicSet.name : null }}
          buttons={
            <ActionButtons
              id={id}
              customerId={customerId}
              name={graphicSetName}
              mutation={deleteGraphicSetMutation}
              history={history}
            />
          }
        />
        <PageSection>
          <GraphicSetData graphicSet={graphicSet} />
        </PageSection>

        {graphicSet && graphicSet.layouts && graphicSet.layouts.length > 0 ? (
          <>
            <PageHeaderBar subtitle title="app.page.asset.layouts" />
            {graphicSet.layouts.map((layout, idx) => (
              <GraphicSetLayoutData key={layout.asset ? layout.asset.id : idx} layout={layout} />
            ))}
          </>
        ) : null}
      </QueryResponseHandler>
    </Dashboard>
  );
};

export default GraphicSetDetailsPage;
